import React, { Component } from 'react'
import styles from './ExchangeSearch.module.scss'

export class ExchangeSearch extends Component {
  handleChange = e => this.props.onInput(e.target.value)

  render() {
    return (
      <div className={styles.exchangeSearch}>
        <div className={styles.icon}></div>
        <input
          className={styles.input}
          ref={this.props.inputRef}
          type='text'
          placeholder='Search for...'
          onChange={this.handleChange}
        />
      </div>
    )
  }
}
